class SearchQuery {
  private conditions: string[] = [];

  addCondition(condition: string) {
    if (condition) {
      this.conditions.push(condition);
    }
    return this;
  }

  addSearchParameter(field: string, comparator: string, value: string) {
    return this.addCondition(`${field} ${comparator} ${value}`);
  }

  addSearchParameters(field: string, comparator: string, values: string[]) {
    if (!values.length) return this;
    const orConditions = values.map(
      (value) => `${field} ${comparator} ${value}`,
    );
    const grouped =
      orConditions.length > 1
        ? `(${orConditions.join(" || ")})`
        : orConditions[0];
    return this.addCondition(grouped);
  }

  toString() {
    return this.conditions.join(" && ");
  }
}

export default SearchQuery;
